export const IMPRINT_URL = "https://constellation.academy/impressum";
export const DATA_PROTECTION_URL = "https://constellation.academy/datenschutz";
export const AGB_URL = "https://constellation.academy/agb";
